import React, { Component } from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import Loading from '../../Loading/LoadingView';
import { isNumeric, isUuid, createCustomPropType } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import SortList from '../../../CommonComponents/SortList';
import CustomDragLayer from '../../../CommonComponents/CustomDragLayer';

class DistributionsView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const { clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate } = this.props;

    const impactTriggerProps = ['whatIf', 'fpId', 'isOPLMonteCarlo'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      const sortFunction = (first, second) => {
        if (first.AccountId > second.AccountId) {
          return 1;
        }
        if (first.AccountId < second.AccountId) {
          return -1;
        }
        return 0;
      };
      const included = cloneDeep(this.props.includedDistributionAccounts).sort(sortFunction);
      const previousIncluded = cloneDeep(previousProps.includedDistributionAccounts).sort(
        sortFunction,
      );

      if (
        !isEqual(included, previousIncluded) ||
        whatIf.DistributionsIsCustom !== previousProps.whatIf.DistributionsIsCustom
      ) {
        fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
      }
    }
  }

  render() {
    const {
      goalId,
      clientId,
      onExcludeAccount,
      onIncludeAccount,
      loading,
      planImpactItems,
      title,
      groupTitle,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      includedDistributionAccounts,
      excludedDistributionAccounts,
      addAccountItem,
      removeAccountItem,
      moveAccountItem,
      moveAccountAndFetch,
      resetToDefault,
      whatIfIsApplied,
      onDrop,
    } = this.props;
    return (
      <div className="what-ifs-layout what-ifs-distributions">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <h5 className="what-ifs-distributions-specify-the-order">
            Specify the order of accounts used to fund your expenses
          </h5>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <CustomDragLayer />
            <SortList
              id="included"
              supressEmptyMessage
              className={`what-ifs-form-fields what-ifs-distributions-included-ul${
                areOptionsLoaded ? ' loaded' : ''
              }`}
              list={includedDistributionAccounts.map((included, index) => ({
                id: `included_${included.AccountId}`,
                className: 'what-ifs-form-field what-ifs-distributions-included-li',
                listClassName: `what-ifs-form-fields what-ifs-distributions-included-ul${
                  areOptionsLoaded ? ' loaded' : ''
                }`,
                item: [
                  <div className="what-ifs-distribution-container">
                    <div className="what-ifs-distributions-order">
                      <div className="what-ifs-distributions-order-pill">{index + 1}</div>
                    </div>
                    <div className="what-ifs-distributions-account">
                      <div className="what-ifs-distributions-account-name">
                        {included.AccountName}
                      </div>
                      <div className="what-ifs-distributions-account-type">
                        {included.AccountType}
                      </div>
                    </div>
                    <div className="what-ifs-distributions-actions">
                      <button
                        type="button"
                        className="what-ifs-distributions-exclude"
                        onClick={onExcludeAccount(
                          includedDistributionAccounts,
                          clientId,
                          goalId,
                          included.AccountId,
                        )}
                      >
                        <i className="fa fa-minus-circle" />
                      </button>
                      <div className="what-ifs-distributions-arrows">
                        <button
                          type="button"
                          className="what-ifs-distributions-arrow"
                          onClick={moveAccountAndFetch(
                            includedDistributionAccounts,
                            clientId,
                            fpId,
                            goalId,
                            whatIf,
                            whatIfTemplate,
                            index,
                            -1,
                          )}
                        >
                          <i className="fa fa-caret-up" />
                        </button>
                        <button
                          type="button"
                          className="what-ifs-distributions-arrow"
                          onClick={moveAccountAndFetch(
                            includedDistributionAccounts,
                            clientId,
                            fpId,
                            goalId,
                            whatIf,
                            whatIfTemplate,
                            index,
                            1,
                          )}
                        >
                          <i className="fa fa-caret-down" />
                        </button>
                      </div>
                    </div>
                  </div>,
                ],
                originalIndex: index,
                sourceListItem: included,
              }))}
              drop={onDrop(clientId, fpId, goalId, whatIf, whatIfTemplate)}
              addItem={addAccountItem}
              removeItem={removeAccountItem}
              moveItem={moveAccountItem(includedDistributionAccounts, clientId, goalId)}
              preventDrag={false}
            >
              <li className="what-ifs-form-field what-ifs-distributions-included-li what-ifs-distributions-included-li-reset-to-default">
                <h5 className="what-if-title">{title}</h5>
                <button
                  type="button"
                  className="what-ifs-distributions-reset-to-default"
                  onClick={resetToDefault(
                    clientId,
                    fpId,
                    goalId,
                    whatIfIsApplied,
                    whatIf,
                    whatIfTemplate,
                  )}
                >
                  <i className="what-ifs-distribution-reset-to-default-i fa fa-sync-alt" />
                  Reset to default
                </button>
              </li>
            </SortList>
            <ul
              className={`what-ifs-form-fields what-ifs-distributions-excluded-ul${
                areOptionsLoaded ? ' loaded' : ''
              }`}
            >
              {excludedDistributionAccounts.length > 0 && (
                <li className="what-ifs-form-field what-ifs-distributions-excluded-li what-ifs-distribution-container what-ifs-distribution-click-to-include-li">
                  <h6 className="what-ifs-distribution-click-to-include">Click to include</h6>
                </li>
              )}
              {excludedDistributionAccounts.map(excluded => (
                <li className="what-ifs-form-field what-ifs-distributions-excluded-li what-ifs-distribution-container">
                  <div className="what-ifs-distributions-order">
                    <button
                      type="button"
                      className="what-ifs-distributions-include"
                      onClick={onIncludeAccount(
                        includedDistributionAccounts,
                        excludedDistributionAccounts,
                        clientId,
                        goalId,
                        excluded.AccountId,
                      )}
                    >
                      <i className="fa fa-plus-circle" />
                    </button>
                  </div>
                  <div className="what-ifs-distributions-account">
                    <div className="what-ifs-distributions-account-name">
                      {excluded.AccountName}
                    </div>
                    <div className="what-ifs-distributions-account-type">
                      {excluded.AccountType}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
DistributionsView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

DistributionsView.propTypes = {
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  addAccountItem: PropTypes.func.isRequired,
  removeAccountItem: PropTypes.func.isRequired,
  moveAccountItem: PropTypes.func.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  planImpactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.string.isRequired,
      proposed: PropTypes.string.isRequired,
    }),
  ).isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  includedDistributionAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  excludedDistributionAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onExcludeAccount: PropTypes.func.isRequired,
  resetToDefault: PropTypes.func.isRequired,
  onIncludeAccount: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  moveAccountAndFetch: PropTypes.func.isRequired,
};

export default DragDropContext(HTML5Backend)(DistributionsView);
